"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var baseAssets_1 = require("../components/base/baseAssets");

var managementAssets_1 = require("../components/management/managementAssets");

var overviewAssets_1 = require("../components/overview/overviewAssets");

var fileAssets_1 = require("../components/file/fileAssets");

exports.assets = {
  baseUrl: '',
  base: baseAssets_1.baseAssets,
  file: fileAssets_1.fileAssets,
  management: managementAssets_1.managementAssets,
  overview: overviewAssets_1.overviewAssets
};